import Input from "../../../design/Input";
import InputCreditCard from "../../../design/InputCreditCard";
import InputDateFourNumbers from "../../../design/InputDateFourNumbers";
import CreditOpenList from "./CreditOpenList";
import { useState } from "react";


function AccountCredait({setDataToPayment:setCreditCard, dataToPayment:creditCard, names}) {
    const [openCreditList, setOPenCreditList] = useState(false);
    const paymentsList = [0, 1, 1.0005, 1.001, 1.002, 1.003, 1.004, 1.005, 1.006, 1.007, 1.008, 1.009];
    
    // const [creditCard, setCreditCard] = useState({
    //     number: "", date: "", cvv: "", id: "", typePaymentes: "Ragolar", paymentes: 1
    // })

    function numberCredit (value) {
        setCreditCard({...creditCard, number: value})
    }

    const upadteSumByPayment = (event) => {
        const value = event.target.value;
        setCreditCard({...creditCard, paymentes: value});

    }

    const clickOnCreditLIst = (data, key) => {
        setCreditCard({...creditCard, ...data, token: key});
        setOPenCreditList(false);
    }

    return (<>
        <div className="account-aufa-continer">

            <div className="account-aufa-credit-card">
                <p 
                style={{'cursor': 'pointer'}}
                onDoubleClick={() => setOPenCreditList(true)}
                > כרטיס אשראי </p>

                <InputCreditCard 
                textView={"0000 0000 0000 0000"} 
                pattern={'creditCard'} 
                value={creditCard.number} 
                onChange={(value) => numberCredit(value)}
                />

                <p>תוקף</p>
                <InputDateFourNumbers textView={"MM/YY"} pattern={'dateCreditCard'} value={creditCard.date} onChange={(value) => setCreditCard({...creditCard, date: value})} />
            
                <p>CVV</p>
                <Input textView={"CVV"} pattern={/^[0-9]{3,4}$/} value={creditCard.cvv} onChange={(value) => setCreditCard({...creditCard, cvv: value})} />

                <p>מ.ז.</p>
                <Input textView={"מ.ז"} pattern={'id'} value={creditCard.id} onChange={(value) => setCreditCard({...creditCard, id: value})} />
            
                <p>סוג תשלום</p>

                <select value={creditCard.typePaymentes} onChange={(event) => setCreditCard({...creditCard, typePaymentes: event.target.value})} >
                    {
                        ["Ragolar", "Paymentes"].map((value, key) => (
                            <option value={value} key={key}> {value} </option>
                        ))
                    }
                </select>

                <p>מס' תשלומים</p>

                <select disabled={creditCard.typePaymentes === "Ragolar"} value={creditCard.paymentes} onChange={upadteSumByPayment} >
                    {
                        Array.from({length: 12}, (_, index) => index + 1).map((value, key) => (
                            <option value={value} key={key}> {`תשלום ${value} - ${0.5 * value}%`} </option>
                        ))
                    }
                </select>
            </div>
            
        </div>

        {
            openCreditList && 
            <CreditOpenList 
            creditList={names}
            setClose={() => setOPenCreditList(false)}
            onDClick={clickOnCreditLIst}
            />
        }
    </>)
}


export default AccountCredait;